/*
 * @Author: Tom Voorneveld <tom>
 * @Date:   2017-11-25T14:52:33+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe Template for other pages than the Landing page
 * @Last modified by:   tom
 * @Last modified time: 2017-12-20T15:23:42+01:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved

  // Activate: import in main.js:
  import './assets/lib/_page_embed.js'
  import './assets/lib/_page_embed.css'

  // Usage example:
  <embpage id="slideshow"
      src="https://www.ft.com"
      caption="click here"></embpage>
*/

import Vue from 'vue'

Vue.component('embpage', {
  name: 'embpage',
  template: `
    <div class="embedpane" @mouseleave="showCaption=true">
      <div class="embedheader" :class="backgroundHeader">
        <a class="float-right" @click="this.window.open(src,'Lorinthe',
            'fullscreen,channelmode,location=no,menubar=no,titlebar=no,status=no,toolbar=no');">
          <icon name="arrows-alt" class="text-white"></icon>
        </a>
      </div>
      <div class="embed-responsive embed-responsive-16by9">
        <h6
            class="embedcaption"
            v-show="showCaption"
            @mouseenter="showCaption=false"
            v-html="caption"></h6>
        <iframe
            class="embed-responsive-item"
            :src="src"></iframe>
      </div>
    </div> <!-- end embed frame -->
  `,
  data: function () {
    return {
      showCaption: true
    }
  },
  props: {
    // url of iframe content
    src: { type: String },
    // project over text, hide when mouse over
    caption: {
      type: String,
      default: 'click here...'
    },
    backgroundHeader: { type: String, default: 'bg-primary' }
  }
})
